import React from 'react';

const emotions = ['Joy', 'Trust', 'Fear', 'Surprise', 'Sadness', 'Disgust', 'Anger', 'Anticipation'];

function EmotionWheel({ emotion, setEmotion }) {
  return (
    <div className="card">
      <h2>Emotion Wheel</h2>
      <div className="emotion-wheel">
        {emotions.map((e, index) => (
          <button
            key={index}
            className={`emotion-btn ${emotion === e ? 'active' : ''}`}
            onClick={() => setEmotion(e)}
          >
            {e}
          </button>
        ))}
      </div>
      {emotion && <p className="feedback">You feel: <strong>{emotion}</strong></p>}
    </div>
  );
}

export default EmotionWheel;
